<template>
  <div class="flex flex-col">
    <!-- ADJUST TIMER -->
    <section class="flex-auto w-full px-4 pt-10 pb-5 text-left">
      <h2 class="font-semibold text-gray-500 dark:text-gray-400 mb-2 text-left select-none">
        Adjust Recorded Time
      </h2>
      <TotalTimeSelector
        :hours="hours"
        :minutes="minutes"
        :seconds="seconds"
        @change-time="changeTime"
        class="w-full lg:w-52 lg:mr-4"
      />
    </section>
    <!-- ADD COMMENT -->
    <section class="flex-auto w-full px-4 pt-3 pb-5 text-left">
      <h2 class="font-semibold text-gray-500 dark:text-gray-400 mb-2 text-left select-none">
        Add Comment
      </h2>
      <div class="w-full mb-8">
        <textarea
          v-model="comment"
          @change="addComment"
          rows="3"
          class="w-full border border-gray-300 dark:border-gray-800 rounded p-2 transition-all focus:ring-1 focus:ring-primary focus:border focus:border-primary"
        />
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"
import TotalTimeSelector from "@/components/Inputs/TotalTimeSelector/TotalTimeSelector.vue"

export default {
  name: "LogLaborPrompt",
  components: {
    TotalTimeSelector
  },
  data() {
    return {
      totalTime: 0,
      hours: "00",
      minutes: "00",
      seconds: "00",
      comment: null
    }
  },
  computed: {
    ...mapGetters(["getProceedArgs"]),
    timer() {
      return this.getProceedArgs[0]
    },
  },
  mounted() {
    this.changeTime(this.timer.elapsed_time)
  },
  methods: {
    ...mapMutations(["setProceedArgs", "setPromptComment"]),
    changeTime(totalTime) {
      if (!totalTime) totalTime = 0
      this.totalTime = totalTime
      this.seconds = (this.totalTime % 60).toString().padStart(2, "0")
      this.minutes = Math.floor(this.totalTime / 60 % 60).toString().padStart(2, "0")
      this.hours = Math.floor(this.totalTime / 3600).toString().padStart(2, "0")
      const updatedTimer = this.timer
      updatedTimer.elapsed_time = totalTime
      this.setProceedArgs([updatedTimer])
    },
    addComment() {
      this.setPromptComment(this.comment)
    }
  },
}
</script>